<div [ngClass]="{'cdk-overlay-dark-backdrop': isCollapsed}" class="comments-custom" (click)="handleClose(false)"></div>
<div class="app_sideDrawer uni-app-sidedrawer-comments comments-custom-sidedrawer"
  [class]="!isCollapsed ? 'collapsed' : ''">
  <div class="d-flex gap-10">
    <div><img src="../../../../assets/images/comments-icon-orange.svg" alt="comment" matTooltip="comment" /></div>
    <div class="header-text mt-1">Comment</div>
  </div>
  <div class="comments-container">
  <div *ngIf="commentsList?.length" class="mt-3">
    <div *ngFor="let comment of commentsList" class="mb-1">
      <div class="comment-history">
        <div>
          <img src="../../../../assets/images/userIcon.svg" class="comment-user" alt="User" matTooltip="User" />
          <span class="comment-user-name">{{comment?.metadata?.createdBy?.userName ?? 'Username'}}</span><span
            class="comment-time">&nbsp;&nbsp;added a comment
            {{service?.getLastSeenFormat(comment?.metadata?.createdDate)}}</span>
        </div>
        <div class="comment-text mt-1">
          {{comment?.commentText}}
        </div>
      </div>
    </div>
  </div>
  <div class="comment-history mt-5" *ngIf="!commentsList?.length">
    No comments available
  </div>
</div>
  <div class="comment-box-container" *ngIf="alertDetails?.status === 'Active'">
    <mat-form-field class="comment-field" appearance="outline">
      <mat-label>Type your comment here...</mat-label>
      <textarea matInput cdkTextareaAutosize [formControl]="comment" #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1" cdkAutosizeMaxRows="2"></textarea>
    </mat-form-field>
    <button mat-raised-button class="analyze-button cursor" [disabled]="!comment?.value"
      [ngClass]="{ '-disabled': !comment?.value }" (click)="saveComment()">Publish</button>
  </div>
</div>